import Layout from '@/pages/layout/Layout'
import {page404,page403,page500, noAuth} from "./errorPage.js"
import singlePage from './singlePage'
import indexRouter from './index/indexRouter'
import companyRouter from "./company/indexRouter"
import usercenterRouter from "./usercenter/indexRouter"
import landRouter from "./land/indexRouter";
import factoryRouter from "./factory/indexRouter";
import warehouseRouter from "./warehouse/indexRouter";
import officebuildingRouter from "./officebuilding/indexRouter";
import dataRouter from "./datas/indexRouter";
import enterpriseRouter from "./enterprise/indexRouter";



const appRouter = {
    path: '/',
    name: 'home_index',
    redirect: {
    	name: 'login-page'
    },
    component: () => import ('@/pages/layout/Layout'),
    children: [
        indexRouter,
        companyRouter,
        usercenterRouter,
        landRouter,
        factoryRouter,
        warehouseRouter,
        officebuildingRouter,
        dataRouter,
        enterpriseRouter,
    ],
};

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    appRouter,
    ...singlePage,
    noAuth,
    page403,
    page500,
    page404,
];



// WEBPACK FOOTER //
// ./src/router/router.js